import { dcFactory } from 'dc';
import GtmComponent from './js/gtm.component.js';

dcFactory.register(GtmComponent);
